module.exports = __webpack_public_path__ + "img/diamond-2-no-shine.59c9828e.png";